import { createSlice } from "@reduxjs/toolkit";

const initialSlice = {
  isAuthenticated: null,
  user: {
    facility: null,
    timezone: null,
    newRegistration: null,
  },
  error: null,
  loading: true,
};

const userSlice = createSlice({
  name: "user",
  initialState: initialSlice,
  reducers: {
    onLogin: (state, action) => {
      state.isAuthenticated = true;
      state.loading = false;
      state.user = action.payload;
    },
    onLogout: (state, _) => {
      state.isAuthenticated = false;
      state.user = {};
      state.error = null;
      state.loading = false;
    },
    onSignup: (state, action) => {
      state.isAuthenticated = true;
      state.user = action.payload;
    },
    onAuthenticationRequest: (state) => {
      state.loading = true;
    },
    onAuthenticationFailure: (state) => {
      state.loading = false;
      state.user = {};
      state.isAuthenticated = false;
    },
    onTourComplete: (state) => {
      state.user.newRegistration = false;
    },
    changeUserFacility: (state, action) => {
      state.user.facility = action?.payload;
    },
    setUser: (state, action) => {
      state.user = action.payload;
    },
  },
});

export const {
  setUser,
  onLogin,
  onLogout,
  onSignup,
  onAuthenticationRequest,
  onAuthenticationFailure,
  onTourComplete,
  changeUserFacility,
} = userSlice.actions;

export default userSlice.reducer;
